import { Injectable } from '@angular/core';

import { NotificationService } from 'src/app/shared/services/notification.service';

import { isArray, isPlainObject } from 'lodash';
import { titleCase } from 'title-case';

@Injectable({
  providedIn: 'root',
})
export class IndicatorService {
  constructor(
    private notifications: NotificationService,
  ) { }

  public success(title, message) {
    this.notifications.showSuccess(
      message,
      title,
    );
  }

  public failed(title, message) {
    this.notifications.showError(
      message,
      title,
    );
  }

  public indicateFailure(error: any, message = null, showUI = true) {
    console.error(error);

    if (!message) {
      const errors = error['error'];

      if (errors && isArray(errors)) {
        message = errors.join(' ');
      }

      if (errors && isPlainObject(errors)) {
        const messages = [];

        Object.entries<any>(errors).forEach(([field, reason]) => {
          const reasons = isArray(reason) ? reason : [reason];
          messages.push(`${titleCase(field)}: ${reasons.join(' ')}`);
        });

        message = messages.join(' ');
      }
    }

    if (!message) {
      message = error['message'];
    }

    if (showUI) {
      this.failed(
        message || 'Something Went Wrong',
        null,
      );
    }

    return null;
  }

  public failureIndicator() {
    return (error: any, message = null) => {
      return this.indicateFailure(error, message);
    };
  }

  public successIndicator(message: string, title: string = null, returns = null) {
    return (value: any) => {
      this.success(title, message);
      return returns ?? value;
    };
  }

  public async usePromise(promise: any) {
    if ('toPromise' in promise) {
      promise = promise.toPromise();
    }

    return await promise.catch(
      this.failureIndicator(),
    );
  }
}
